// extracted by mini-css-extract-plugin
export var buttons = "_9g-0";
export var buttonsActive = "_9g-h";
export var cancelConfirm = "_9g-1";
export var closeButton = "_9g-2";
export var column = "_9g-3";
export var container = "_9g-4";
export var detailHeader = "_9g-6";
export var detailTitle = "_9g-7";
export var detailsContent = "_9g-5";
export var header = "_9g-8";
export var headerWithClose = "_9g-9";
export var icon = "_9g-a";
export var infoIcon = "_9g-c";
export var informationContainer = "_9g-b";
export var sideDrawer = "_9g-d";
export var sideDrawerOpen = "_9g-e";
export var stickyFooter = "_9g-f";
export var typeOption = "_9g-g";